import { CommandType } from "../../../../common/services/cqs/CommandType";
import { VKAtgardLeveransvirkesvolymDTO } from "../../models/atgard-leveransvirkesvolym-models";
import { AtgardLeveransvirkesVolymCommandBase } from "./AtgardLeveransvirkesVolymCommandBase";

export class UpdateAtgardLeveransvirkesVolymCommand extends AtgardLeveransvirkesVolymCommandBase {
// eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "UpdateAtgardLeveransvirkesVolymCommand";

    constructor(leveransvirkesvolym: VKAtgardLeveransvirkesvolymDTO, kontraktGuid: string) {
        super(leveransvirkesvolym, UpdateAtgardLeveransvirkesVolymCommand.$type, CommandType.Replace);
        this.kontraktGuid = kontraktGuid;
    }
}
